import React from 'react';
import { Link } from '@i18n';
import { BLOG_ARTICLE } from '@routes';
import { humanize } from '@lib/helpers';
import { departmentList } from '@screens/Finder/department';
import {
  StyledArticleSummary,
  StyledCardDate,
  StyledCardInner,
  StyledCardTitle,
  StyledCardWrapper,
  StyledImageCover,
  StyledLink,
  StyledPostImage,
  StyledDepartment
} from './styles';

const ArticleCard = ({ article }) => (
  <StyledCardWrapper>
    <Link passHref href={BLOG_ARTICLE} params={{ slug: article.attributes.slug }}>
      <StyledLink>
        <StyledCardInner>
          <StyledImageCover>
            <StyledPostImage
              src={
                article.attributes.listing_image?.url
                || article.attributes.cover_image.url
                || '../../../../../../../static/images/Blog-default-image.jpg'
              }
            />
          </StyledImageCover>
          <StyledDepartment>{departmentList[article.attributes.department] || (humanize(article.attributes.department.split('_')))}</StyledDepartment>
          <StyledCardTitle>{article.attributes.title}</StyledCardTitle>
          <StyledArticleSummary
            dangerouslySetInnerHTML={{ __html: article.attributes.article_summary }}
          />
          <StyledCardDate>{article.attributes.published_at}</StyledCardDate>
        </StyledCardInner>
      </StyledLink>
    </Link>
  </StyledCardWrapper>
);

export default ArticleCard;
